const dbName = 'tab_userguild_db';
const version = 1;
const tableName = 'user_guild';
const tableIndex = 'key';
const openDbPromise = openDatabase(dbName, version, tableName);
export const readDB = (dkey) => {
    if (!openDbPromise) {
        return Promise.reject('链接indexedDB失败');
    }
    return openDbPromise === null || openDbPromise === void 0 ? void 0 : openDbPromise.then(db => new Promise((resolve, reject) => {
        const transaction = db.transaction([tableName], 'readonly');
        const objectStore = transaction.objectStore(tableName);
        try {
            const request = objectStore.get(dkey);
            request.onerror = (event) => {
                reject(event);
            };
            request.onsuccess = (event) => {
                const { result } = event.target;
                if (result) {
                    resolve(result.value);
                }
                else {
                    resolve(null);
                }
            };
        }
        catch (err) {
            reject(err);
        }
    }));
};
export const writeDB = (dkey, data) => {
    if (!openDbPromise) {
        Promise.reject('链接indexedDB失败');
    }
    return openDbPromise === null || openDbPromise === void 0 ? void 0 : openDbPromise.then(db => new Promise((resolve, reject) => {
        const transaction = db.transaction([tableName], 'readwrite');
        const objectStore = transaction.objectStore(tableName);
        try {
            const request = objectStore.put({
                key: dkey,
                value: data,
            });
            request.onerror = (event) => {
                console.log(event);
                reject(event);
            };
            request.onsuccess = () => {
                resolve(true);
            };
        }
        catch (error) {
            reject(error);
        }
    }));
};
function isSupportIndexDB() {
    return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
}
function openDatabase(name, version, store) {
    if (!isSupportIndexDB()) {
        return;
    }
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(name, version);
        request.onerror = (event) => {
            reject(event);
        };
        request.onsuccess = (event) => {
            resolve(event.target.result);
        };
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            switch (event.oldVersion) {
                case 0:
                    db.createObjectStore(store, {
                        keyPath: tableIndex,
                    });
            }
        };
    });
}
